"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMedicalTreatment = createMedicalTreatment;
const events_1 = require("../../../events");
const medicalTreatment_1 = require("../../../forms/ktx/transplantation-screening/medical-history/medicalTreatment");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    title: {
        id: "ktx.dashboard.medical_treatment",
        defaultMessage: "Gyógyszeres kezelés"
    },
    drugType: {
        id: "ktx.dashboard.medical_treatment.drug_type",
        defaultMessage: "Gyógyszer csoport"
    },
    calciumActiveIngredient: {
        id: "ktx.dashboard.medical_treatment.calcium_active_ingredient",
        defaultMessage: "Hatóanyag"
    },
    vitaminDActiveIngredient: {
        id: "ktx.dashboard.medical_treatment.vitamin_d_active_ingredient",
        defaultMessage: "Hatóanyag"
    },
    erythropoetinProductActiveIngredient: {
        id: "ktx.dashboard.medical_treatment.erythropoetin_product_active_ingredient",
        defaultMessage: "Hatónyag"
    }
};
function createMedicalTreatment(intl, options) {
    const lists = createList(intl, options);
    const content = (0, shared_1.createGroupContent)(lists);
    return (0, shared_1.createGroup)(intl, { label: messages.title, content });
}
function createList({ formatMessage, formatMessageMap }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.medicalHistoryQueries.medicalTreatment);
    if (event === undefined) {
        return [undefined];
    }
    return event.value.drugTypes.map(element => {
        const items = [];
        if (element.calciumActiveIngredient) {
            const calciumActiveIngredient = element.calciumActiveIngredient
                .map(c => formatMessageMap(medicalTreatment_1.calciumActiveIngredientMessages, c))
                .join(", ");
            items.push({
                type: "list-item",
                label: formatMessage(messages.calciumActiveIngredient),
                value: calciumActiveIngredient
            });
        }
        if (element.erythropoetinProductActiveIngredient) {
            const erythropoetinProductActiveIngredient = element.erythropoetinProductActiveIngredient
                .map(e => {
                let ret = formatMessageMap(medicalTreatment_1.erythropoetinProductActiveIngredientMessages, e);
                if (e === medicalTreatment_1.ErythropoetinProductActiveIngredient.OTHER) {
                    ret = `${ret} - ${element.erythropoetinProductActiveIngredientTypeOther}`;
                }
                return ret;
            })
                .join(", ");
            items.push({
                type: "list-item",
                label: formatMessage(messages.erythropoetinProductActiveIngredient),
                value: erythropoetinProductActiveIngredient
            });
        }
        if (element.vitaminDActiveIngredient) {
            const vitaminDActiveIngredient = element.vitaminDActiveIngredient
                .map(v => {
                let ret = formatMessageMap(medicalTreatment_1.vitaminDactiveIngredientMessages, v);
                if (v === "other") {
                    ret = `${ret} - ${element.vitaminDActiveIngredientTypeOther}`;
                }
                return ret;
            })
                .join(", ");
            items.push({
                type: "list-item",
                label: formatMessage(messages.vitaminDActiveIngredient),
                value: vitaminDActiveIngredient
            });
        }
        let label = formatMessageMap(medicalTreatment_1.drugTypeMessages, element.drugType);
        if (element.drugTypeOther) {
            label = element.drugTypeOther;
        }
        return {
            type: "list",
            attachments: (0, events_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            origin: event.origin,
            label: label,
            items
        };
    });
}
